import React from 'react';
import { formatDuration } from '../../utils/duration';
import { getSupportStatusLabel } from '../../utils/supportStatus';
import './ChatList.css';

const REOPENABLE_STATUSES = new Set(['finalizado', 'encerrado', 'em_finalizacao']);

const ChatList = ({ chats, onChatSelect, onPullSupport, onMarkAsRead, selectedChatId }) => {
  const sortedChats = [...chats].reverse();

  const getSlaStatus = (timestamp, status) => {
    if (!timestamp) return { label: 'Sem SLA', level: 'sla-unknown' };
    if (status === 'finalizado' || status === 'em_finalizacao') {
      return { label: 'SLA Encerrado', level: 'sla-unknown' };
    }
    const last = new Date(timestamp).getTime();
    if (Number.isNaN(last)) return { label: 'Sem SLA', level: 'sla-unknown' };
    const ageSeconds = Math.floor((Date.now() - last) / 1000);
    const formatted = formatDuration(ageSeconds, { shortMinutes: true, minuteUnit: 'm' });
    if (ageSeconds < 5 * 60) return { label: `SLA ${formatted}`, level: 'sla-ok' };
    if (ageSeconds < 15 * 60) return { label: `SLA ${formatted}`, level: 'sla-warn' };
    return { label: `SLA ${formatted}`, level: 'sla-risk' };
  };

  return (
    <div className="chat-list">
      {sortedChats.map((chat, index) => (
        (() => {
          const displayName = chat.customer_name || chat.name || 'Cliente';
          const rawPhone = chat.customer_phone || chat.chatId || '';
          const displayPhone = rawPhone.includes('@') ? rawPhone.split('@')[0] : rawPhone;
          const phoneLabel = displayPhone || 'Sem telefone';
          return (
        <div
          key={`${chat.chatId}-${chat.TicketNumber}-${index}`}
          className={`chat-item ${chat.unread ? 'unread' : ''} ${chat.chatId === selectedChatId ? 'selected' : ''}`}
          onClick={() => {
            onChatSelect(chat);
            onMarkAsRead(chat.chatId);
          }}
        >
          <div className="chat-info">
            <div className="chat-ticket">
              <span>#{chat.TicketNumber}</span>
              <span className={`chat-status status-${chat.status || 'unknown'}`}>
                {getSupportStatusLabel(chat.status)}
              </span>
            </div>
            <div className="chat-details">
              <div className="chat-phone">
                {phoneLabel}
              </div>
              <div className="chat-name">
                {displayName}
              </div>
            </div>
            <div className="chat-meta">
              {(() => {
                const sla = getSlaStatus(chat.lastTimestamp, chat.status);
                return <span className={`sla-badge ${sla.level}`}>{sla.label}</span>;
              })()}
              {chat.unread && <span className="unread-pill">Novo</span>}
            </div>
            <div className="chat-last-message">
              {chat.lastMessage ? chat.lastMessage.slice(0, 20) : 'Sem mensagem'}...
            </div>
          </div>
          {(chat.status === 'com_robo' || chat.status === 'em_disparo') && (
            <button
              className="pull-support-button"
              onClick={(e) => { e.stopPropagation(); onPullSupport(chat.TicketNumber); }}
            >
              Puxar Atendimento
            </button>
          )}
          {REOPENABLE_STATUSES.has(chat.status) && (
            <button
              className="pull-support-button"
              onClick={(e) => { e.stopPropagation(); onPullSupport(chat.TicketNumber); }}
            >
              Reabrir Atendimento
            </button>
          )}
        </div>
          );
        })()
      ))}
    </div>
  );
};

export default ChatList;
